var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M10 0C10.1859 0 10.359 0.107606 10.4594 0.285549L19.9136 17.0442C20.0214 17.2352 20.0288 17.4779 19.9331 17.677C19.8374 17.8761 19.6537 18 19.4542 18H0.545837C0.34626 18 0.162594 17.8761 0.0668753 17.677C-0.0288438 17.4779 -0.0213537 17.2352 0.0864077 17.0442L9.54057 0.285549C9.64095 0.107606 9.81409 0 10 0ZM10 1.77022L1.54449 16.7586H18.4555L10 1.77022Z",
          fill: "#FF0000"
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M10 6C10.4142 6 10.75 6.33579 10.75 6.75L10.75 11.25C10.75 11.6642 10.4142 12 10 12C9.58579 12 9.25 11.6642 9.25 11.25L9.25 6.75C9.25 6.33579 9.58579 6 10 6Z",
          fill: "#212322"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.75 13.75C10.75 14.1642 10.4142 14.5 10 14.5C9.58579 14.5 9.25 14.1642 9.25 13.75C9.25 13.3358 9.58579 13 10 13C10.4142 13 10.75 13.3358 10.75 13.75Z",
          fill: "#212322"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }